// web/src/stores/localeStore.ts
// Locale + default currency derived from the user's profile jurisdiction.
// Populated once on login by useLocaleInit; consumed by rendering leaf components.
import { create } from "zustand";
import { localeFromJurisdiction, DEFAULT_LOCALE, DEFAULT_CURRENCY } from "../lib/formatters";
export const useLocaleStore = create()((set) => ({
    locale: DEFAULT_LOCALE,
    currency: DEFAULT_CURRENCY,
    setFromJurisdiction: (jurisdiction) => {
        const { locale, currency } = localeFromJurisdiction(jurisdiction);
        set({ locale, currency });
    },
}));
